import React, { useEffect, useState } from 'react'
import "./Footer.css"
import { BiLogoFacebook } from "react-icons/bi";
import { BsTwitterX } from "react-icons/bs";
import { AiOutlineYoutube } from "react-icons/ai";
import { AiOutlineInstagram } from "react-icons/ai";
import { RiLinkedinLine } from "react-icons/ri";
import octicongraph from "../../assets/images/octicon-graph.png"
import trainingprogram from "../../assets/images/training-program.png"
import photography from "../../assets/images/photography.png"
import List from "../../assets/images/list.png"
import transferpolicy from "../../assets/images/transfer-policy.png"
import register from "../../assets/images/register.png"
import phone from "../../assets/images/phone.png"
import login from "../../assets/images/login.png"
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../LanguageProvider/LanguageProvider ';
import { Baseurl } from "../../Utils/Utils";
import { getVisitorCount } from '../../services/api/outer';
const Footer = ({ homePageContent, getUserInfo }) => {
    const { language, setLanguage } = useLanguage()
    const navigate = useNavigate()
    const location = useLocation();
    const [visitorCountData, setVisitorCountData] = useState(null);
    const iconMap = {
        Facebook: <BiLogoFacebook />,
        "Twitter(X)": <BsTwitterX />,
        Youtube: <AiOutlineYoutube />,
        Instagram: <AiOutlineInstagram />,
        LinkedIn: <RiLinkedinLine />,
      };

    
    useEffect(() => {
        getVisitorCountData()
    }, [])
  
    const getVisitorCountData = async () => {
        try {
            const visitorCountResponse = await getVisitorCount();
            setVisitorCountData(visitorCountResponse?.data);
        } catch (err) { }
    };

      
    const activeHome = location.pathname == "/" || location.pathname == "/login" || location.pathname == "/signup" || location.pathname == "/reset-password" || location.pathname == "/forgot-password"
    return (
        <> { homePageContent?.footer_desc && homePageContent?.footer_desc ? <div className='ft-main m-0' style={{ display: getUserInfo && !activeHome ? "none" : "block" }}>
            <div className="container">
                <div className='ft-upper row'>
                    <div className='upper-box1 col-md-5'>
                        <p className='box2-pera-heading'>{language ? homePageContent?.footer_desc.find((d) => d.type === "1")?.title_hi ?? '' : homePageContent?.footer_desc.find((d) => d.type === "1")?.title_en ?? ''}</p>
                        <p className='box2-pera-line'></p>
                        <p className='box1-pera'>{language ? homePageContent?.footer_desc.find((d) => d.type === "1")?.content_hi ?? '' : homePageContent?.footer_desc.find((d) => d.type === "1")?.content_en ?? ''} </p>
                        <div className="box1-icons">
                            {homePageContent?.social_media_link?.filter((item) => item.status === "1")?.map((link) => (
                                <div key={link.id} className="b1-icons-inner">
                                    <a
                                        href={link?.url} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="social-link"
                                    >
                                        <img
                                        src={Baseurl() + "/" + link?.logo}
                                        alt={link.name || "social link"}
                                        />
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-1"></div>
                    <div className='upper-box2 col-md-3'>
                        <p className='box2-pera-heading'>{language ? "ट्रैवल ट्रेड" : "Travel Trade"}</p>
                        <p className='box2-pera-line'></p>
                        <div className='box2-pera-content'>
                        {homePageContent?.footer_link.map(link => (
                            <div key={link.id} className="ft-box2-lines">
                                <img src={Baseurl() + "/" + link.image || 'default-icon.png'} alt={link.name} />
                                <a href={link?.link} target="_blank" style={{ color: 'inherit', textDecoration: 'none' }} >
                                    <p>{language ? link.name_hi : link.name_en}</p>
                                </a>
                            </div>
                        ))}
                        </div>
                    </div>
                    <div className='upper-box3 col-md-2'>
                        <p className='box3-pera-heading'>{language ? "महत्वपूर्ण लिंक" : "Important Links"}</p>
                        <p className='box3-pera-line'></p>
                        <div className='box3-pera-content'>
                            <div className='ft-box2-lines' onClick={() => navigate("/signup")}> <img src={login} alt="" />  <p> {language ? "रेजिस्ट्रेशन" : "Registration"}</p></div>
                            <div className='ft-box2-lines' onClick={() => navigate("/login")}> <img src={register} alt="" /><p> {language ? "लॉग इन " : "Login"}</p></div>
                            {
                                homePageContent?.new_header_menu
                                ?.filter((item) => item.status === "1") // Filter items with status 1
                                .map((item) =>
                                    item.url_type === "2" ? ( // Check if it's an external link
                                        <a
                                            key={item.id}
                                            href={item.url}
                                            target="_blank"
                                            className='ft-box2-lines'
                                            rel="noopener noreferrer"
                                            style={{
                                                textDecoration: "none",
                                            }}
                                        >
                                            <img src={`${Baseurl()}/${item?.image}`} alt="" />
                                            <p>{language ? item?.name_hi : item?.name_en}</p>
                                        </a>
                                    ) : (
                                        <div
                                            className='ft-box2-lines'
                                            key={item.id}
                                            onClick={() =>
                                                navigate(`/${item?.url}`, {
                                                    state: {
                                                        content_en: item?.content_en,
                                                        content_hi: item?.content_hi,
                                                        page_id: item?.id,
                                                        title_en: item?.name_en,
                                                        title_hi: item?.name_hi,
                                                    },
                                                })
                                            }
                                        >
                                            <img src={`${Baseurl()}/${item?.image}`} alt="" />
                                            <p>{language ? item?.name_hi : item?.name_en}</p>
                                        </div>
                                    )
                                )
                            }
                            {
                                homePageContent?.top_footer_link
                                ?.filter((item) => item.status === "1") // Filter items with status 1
                                .map((item) =>
                                    item.url_type === "2" ? ( // Check if it's an external link
                                        <a
                                            key={item.id}
                                            href={item.url}
                                            target="_blank"
                                            className='ft-box2-lines'
                                            rel="noopener noreferrer"
                                            style={{
                                                textDecoration: "none",
                                            }}
                                        >
                                            <img src={`${Baseurl()}/${item?.image}`} alt="" />
                                            <p>{language ? item?.name_hi : item?.name_en}</p>
                                        </a>
                                    ) : (
                                        <div
                                            className='ft-box2-lines'
                                            key={item.id}
                                            onClick={() =>
                                                navigate(`/${item?.url}`, {
                                                    state: {
                                                        content_en: item?.content_en,
                                                        content_hi: item?.content_hi,
                                                        page_id: item?.id,
                                                        title_en: item?.name_en,
                                                        title_hi: item?.name_hi,
                                                    },
                                                })
                                            }
                                        >
                                            <img src={`${Baseurl()}/${item?.image}`} alt="" />
                                            <p>{language ? item?.name_hi : item?.name_en}</p>
                                        </div>
                                    )
                                )
                            }
                            {/* <div className='ft-box2-lines' onClick={() => navigate("/privacy-policy")}><img src={transferpolicy} alt="" /><p>{language ? "गोपनीयता नीति" : "Privacy Policy"}</p></div> */}
                            <div className='ft-box2-lines' onClick={() => navigate("/contact-us")}><img src={phone} alt="" /><p>{language ? "संपर्क करें" : "Contact Us"}</p></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ft-lower">
                <div className='container'>
                    <div className='ft-lower-box1'>
                        <p>{language ? homePageContent?.footer_desc.find((d) => d.type === "2")?.content_hi ?? '' : homePageContent?.footer_desc.find((d) => d.type === "2")?.content_en ?? ''}</p>
                    </div>
                    <div className='ft-lower-box2-p3'>
                        <div className='total-visitors'>
                            <div className='visitor-heading'>
                            <span>{language ? "कुल आगंतुक" : "Total Visitors"}</span>
                            </div>
                            <div className='visitors-count'>
                                {visitorCountData?.visitor_count ?? 0}
                            </div>
                        </div>
                        {visitorCountData?.ip_address ? <div className='ip-tracking'>
                            <div className='ip-heading'>
                                <span>{language ? "आईपी ​​ट्रैकिंग" : "IP Tracking"}</span>
                            </div>
                            <div className='visitors-count'>
                              {visitorCountData?.ip_address}
                            </div>
                        </div> : <></>}
                       </div>
                    <div className='ft-lower-box2'>
                        <div className='ft-lower-box2-p1'><p>{language ? homePageContent?.footer_desc.find((d) => d.type === "3")?.content_hi ?? '' : homePageContent?.footer_desc.find((d) => d.type === "3")?.content_en ?? ''}</p></div>
                
                       
                        <div className='ft-lower-box2-p2'>
                            {
                                homePageContent?.bottom_footer_link
                                ?.filter((item) => item.status === "1") // Filter items with status 1
                                .map((item) =>
                                    item?.url_type === "2" ? ( // Check if it's an external link
                                        <a
                                            key={item.id}
                                            href={item.url}
                                            target="_blank"
                                            style={{
                                                textDecoration: "none",
                                            }}
                                        >
                                            {language ? item?.name_hi : item?.name_en}
                                        </a>
                                    ) : (
                                        <p
                                            key={item.id}
                                            onClick={() =>
                                                navigate(`/${item?.url}`, {
                                                    state: {
                                                        content_en: item?.content_en,
                                                        content_hi: item?.content_hi,
                                                        page_id: item?.id,
                                                        title_en: item?.name_en,
                                                        title_hi: item?.name_hi,
                                                    },
                                                })
                                            }
                                        >
                                            {language ? item?.name_hi : item?.name_en}
                                        </p>
                                    )
                                )
                            }
                        </div>
                        
                    </div>
                    <p className="footer-copyright-text"><span className=" TextLight text-xs">{language ? "द्वारा डिजाइन और विकसित" : "Designed and Developed by"}</span><a href="https://drishinfo.com/" target='_blank' className="mr-2 text-white text-xs"><svg className="inline-block ms-2 me-0.5 developer-logo" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.05947 1.32367C0.51397 1.86916 1.16973 2.69421 1.56579 3.03855C1.75972 3.02714 2.18347 3.00548 2.32699 3.01011C2.50639 3.0159 2.69447 2.86543 3.00409 2.88569C3.3137 2.90594 3.22689 2.89148 3.43233 3.05641C3.63778 3.22134 3.64646 3.35445 3.63488 3.49913C3.62331 3.6438 3.51975 3.70262 3.40204 3.71978C3.28434 3.73695 3.21813 3.64131 3.05138 3.58491C2.91798 3.53979 2.81278 3.67537 2.77685 3.7488H2.23806C2.31096 3.86438 2.49092 4.14676 2.62748 4.35161C2.79819 4.60767 2.5464 4.70234 2.70025 5.15499C2.8541 5.60763 3.58914 6.53141 4.23017 7.22372C4.8712 7.91603 5.96033 8.06479 6.50266 8.15755C7.04498 8.25032 6.92354 8.64729 6.99611 8.81888C7.06868 8.99048 7.37575 9.6744 7.50613 9.73488C7.63651 9.79535 7.70053 9.87721 7.89726 10.0148C8.05465 10.1249 8.20912 10.3701 8.26667 10.4789C8.14595 10.5536 7.87177 10.7406 7.74084 10.8913C7.57718 11.0796 7.3178 12.043 7.18742 12.2023C7.05704 12.3617 5.72428 12.4558 4.98546 12.9194C4.39441 13.2902 3.79273 14.286 3.56578 14.7375H8.53467C8.56848 14.4767 8.64477 13.9349 8.67954 13.8538C8.723 13.7524 8.35522 13.6437 8.22321 13.5713C8.09121 13.4989 8.23045 13.4482 8.58538 13.0932C8.9403 12.7383 9.50888 12.6028 10.2458 12.3677C10.9827 12.1326 10.8476 11.8826 10.7901 11.8279C10.7327 11.7731 9.83934 10.7765 9.77055 10.7655C9.70176 10.7545 9.38192 10.9846 8.92813 11.0801C8.47435 11.1757 7.89637 11.7823 7.70053 11.8826C7.50468 11.9829 7.58111 11.6199 7.60499 11.4479C7.6241 11.3104 8.1131 10.8423 8.35522 10.6254C8.37588 10.6048 8.41722 10.5465 8.41722 10.4789C8.41722 10.3943 8.13539 9.93215 7.85097 9.73488C7.56654 9.5376 7.27842 9.11594 7.2177 9.04308C7.15698 8.97021 7.16103 8.75567 7.17317 8.67471C7.18531 8.59375 7.17317 8.55731 7.27842 8.56946C7.38367 8.5816 7.49284 8.64729 7.74084 8.91759C7.98885 9.18789 8.76668 9.49251 8.99777 9.54324C9.22887 9.59397 9.35872 9.73841 9.4584 9.61596C9.55807 9.49351 10.1974 8.797 10.3735 8.64729C10.5496 8.49758 10.444 8.17175 9.55453 7.99562C8.66509 7.8195 8.07093 7.28694 7.85097 7.10082C7.63101 6.9147 7.86789 6.88086 8.11323 6.73703C8.35858 6.59321 8.04555 5.71336 8.25706 5.60337C8.46856 5.49339 8.49394 5.75566 8.73083 5.76412C8.96771 5.77258 8.94606 5.54415 9.4584 5.15499C9.97074 4.76582 10.5159 3.58986 10.6682 3.29375C10.8205 2.99765 11.1589 2.84457 11.8442 2.73538C12.5294 2.62619 15.6883 2.02921 15.8399 1.95925C15.9915 1.88929 14.6506 1.45786 12.7383 1.06142C10.8261 0.664976 9.14342 0.747638 8.94606 0.790811C8.7487 0.833983 8.86588 0.85248 8.1998 0.846313C7.53371 0.840145 7.26234 1.2842 7.213 1.52473C7.16366 1.76526 6.78128 2.54237 6.63943 2.84457C6.49758 3.14678 5.88182 3.77265 5.61214 4.02104C5.34246 4.26943 5.19343 3.97846 5.10827 3.85072C5.02311 3.72297 3.63214 2.332 3.31989 2.17587C3.00763 2.01975 1.74134 0.641795 1.05947 1.32367Z" fill="white"></path></svg><span className="drish-developed  TextLight text-xs hover:text-red-500 hover:underline-offset-2 hover:underline">{language ? "दृश इन्फोटेक लिमिटेड." : "Drish Infotech Ltd."} </span></a></p>
                </div>
            </div>
        </div> : '' } </>
    )
}
export default Footer